'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./Button.css');

require('./Button-mobile.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(props) {
  if (props.previewQuizScreen) {
    return;
  }
  if (props.data.get('buttonType') === 'next') {
    props.handleNext();
  } else if (props.data.get('buttonType') === 'hyperlink') {
    if (props.trackEvent) {
      props.trackEvent({
        action: 'External link',
        label: 'type=' + props.data.get('blockType') + ' url=' + props.data.get('hyperlink')
      });
    }
    props.handleNext(props.data.get('hyperlink'));
  }
};

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'wsequiz_button wsequiz_button-' + (props.data.get('blockType') || 'primary') },
    _react2.default.createElement(
      'button',
      { tabIndex: '0', type: 'button', onClick: function onClick() {
          return handleClick(props);
        } },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          props.data.get('buttonText')
        )
      )
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/blocks/Button.js
// module id = 149
// module chunks = 0